import { JobStatusEnum, JobTypeEnum } from '../../enums';

export interface IJobCreatedBySchema {
    userId?: string;
    name: string;
}

export interface IJobSchema {
    id?: string;
    status?: JobStatusEnum;
    createdAt?: string;
    createdBy?: IJobCreatedBySchema;
    type: JobTypeEnum;
}
